import { useFavorites } from '../context';

const FavoriteList = ({ onOpenDetails }) => {
  const { favorites } = useFavorites();

  return (
    <div className="favorite-list">
      <h2>Favorites</h2>
      {favorites.length === 0 ? (
        <p>No favorite meals yet.</p>
      ) : (
        <ul>
          {favorites.map((meal) => (
            <li key={meal.idMeal}>
              <button type="button" onClick={() => onOpenDetails(meal)}>
                {meal.strMeal}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FavoriteList;